(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('task-verification-list', {
            parent: 'functions_menu',
            url: '/task-verification-list?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN','VERIFICATION','VERIFICATION_BY_PRODUCT_LINE'],
                pageTitle: 'abcQualityMatchApp.taskList.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/task/task-verification-list/task-verification-list.html',
                    controller: 'TaskVerificationListController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'tic.title,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taskVerification');
                    $translatePartialLoader.addPart('ticket');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
